import ApiService from "@/core/services/api.service";

let url = process.env.VUE_APP_API_ADMIN;

class RateLimit {
  get() {
    return ApiService.get(url, "rate_limits");
  }
}
export default new RateLimit();
